module.exports = __webpack_public_path__ + "static/media/baby.b0f7b808.svg";